const steps = [
  {
    n: "01",
    title: "Elegí tu auto y batería actual",
    text: "Seleccioná tu modelo EV y el porcentaje de carga con el que salís.",
    testid: "step-1",
  },
  {
    n: "02",
    title: "Ingresá origen y destino",
    text: "De Montevideo a donde quieras: LleGO analiza la ruta y el clima.",
    testid: "step-2",
  },
  {
    n: "03",
    title: "Recibí las paradas óptimas",
    text: "Paradas de carga recomendadas con alternativas, tiempos y costos en $U.",
    testid: "step-3",
  },
];

export default function Steps() {
  return (
    <section className="section section-alt" id="como-funciona" data-testid="steps-section">
      <div className="container">
        <div className="section-head reveal">
          <h2>Cómo funciona</h2>
          <p>Tres pasos y salís a la ruta sin incertidumbre.</p>
        </div>
        <ol className="steps-grid">
          {steps.map((s, i) => (
            <li
              key={s.n}
              className="step-card reveal"
              style={{ transitionDelay: `${i * 120}ms` }}
              data-testid={s.testid}
            >
              <span className="step-number">{s.n}</span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
